/** Shared constants for offer tracking. */

export enum OfferType {
  rbc_funded_points = "rbc_funded_points",
  hotel_merch = "hotel_merch",
  hts_media = "hts_media",
}

/** Screen where a banner / modal / list-card event occurred. */
export enum OfferScreen {
  home = "home",
  hotel_list = "hotel_list",
  hotel_shop = "hotel_shop",
  hotel_checkout = "hotel_checkout",
  offers_page = "offers_page",
  deals_page = "deals_page",
  wallet = "wallet",
  all_offers = "all_offers",
}

/** How the user reached the offers landing page (`offers_entry`). */
export enum OfferEntrySource {
  offer_tile = "offer_tile",
  offer_banner = "offer_banner",
  offer_modal = "offer_modal",
  deeplink = "deeplink",
}

/** Outcome of claiming/loading an offer (RBC-2641). */
export enum ClaimStatus {
  claimed = "claimed",
  already_claimed = "already_claimed",
  failed = "failed",
  ineligible = "ineligible",
  not_applicable = "not_applicable",
}

/**
 * Whether the user already had the offer loaded before the event.
 * Sent as a string on viewed/tapped events (RBC-2641).
 */
export enum IsOfferClaimed {
  true = "true",
  false = "false",
  not_applicable = "not_applicable",
}

/** Section within the wallet page where a tile/modal event occurred (RBC-2641). */
export enum WalletSection {
  claimed_offers = "claimed_offers",
  travel_offers = "travel_offers",
}

/**
 * Why the 3X bonus-earn offer did not apply to a hotel booking
 * (`offer_ineligible_reason` on hotel_complete_buy). One value per event, in
 * this precedence order.
 */
export enum OfferIneligibleReason {
  failed_purchase = "failed_purchase",
  not_launched = "not_launched",
  tier_ineligible = "tier_ineligible",
  no_cash_portion = "no_cash_portion",
  non_rbc_card = "non_rbc_card",
}

// TODO: offer_id should be the UUID from the offer config — populate once available.
export const HOTEL_3X_EARN_OFFER_ID = "";
export const HOTEL_DEALS_OFFER_ID = "";

// Human-readable offer names — hardcoded per campaign until sourced from config.
export const HOTEL_3X_EARN_OFFER_NAME = "hotel-3x-earn-fall-2026";
export const HOTEL_DEALS_OFFER_NAME = "hotel-funded-deals";
